<template lang="pug">
  .container
    .main_block
      .webiomed
        .logo
          img(src = "../../assets/wmlogo.png")
        .text
          .header Webiomed
          .sub_text Система поддержки принятия врачебных решений
      .login
        .form(@keyup.enter="login")
          label Имя пользователя
          input(type="text" v-model="username" )
          label Пароль
          input(type="password" v-model="password" )
          .error_text(v-if="error") Неправильно введено имя пользователя или пароль
          .btn
            button(@click="login" :disable="!password || !username") Войти
        .join
          span.social_text Связаться с нами :
          span.social_icons
            a(:href="'mailto:support@webiomed.ai'" add target="_blank")
              v-icon.mail(name="envelope" scale="1.2" a-href="mailto:support@webiomed.ai")
            a(:href="'https://vk.com/webiomed'" add target="_blank")
              v-icon.vk(name="brands/vk" scale="1.4")
            a(:href="'https://www.facebook.com/webiomed/'" add target="_blank")
              v-icon.facebook(name="brands/facebook-f" scale="1.1")
            a(:href="'https://twitter.com/webiomed'" add target="_blank")
              v-icon.twitter(name="brands/twitter" scale="1.2")
      .info
          .section1
            b © ООО «К-Скай» 2018—{{(new Date()).getFullYear()}}
            div Все права защищены
            a(:href="'https://webiomed.ai'" add target="_blank")
              b https://webiomed.ai
          .section2
            div Регистрационное удостоверение на медицинское изделие № РЗН 2020/9958
              span(v-if="prod") , промышленная площадка.
              span(v-if="!prod") , тестовая площадка.
            div Версия {{version}}, дата релиза {{releaseDate}}
            .link
              router-link(:to = "{name: 'SystemUsageInforamation'}" target="_blank") Информация об использовании &nbsp;
                v-icon(name="external-link-alt")
</template>

<script>
import Icon from 'vue-awesome/components/Icon'
import axios from 'axios'

export default {
  components: {
    'v-icon': Icon
  },
  beforeCreate () {
    axios
      .get('dhra/api/v1/system/about/')
      .then(result => {
        if (result.data.version !== '-') {
          let items = result.data.version.split('-')
          this.version = items[0]
          this.releaseDate = this.getValidDate(items[1])
        }
        if (result.data.prod) {
          this.prod = result.data.prod
        }
      })
      .catch(error => console.log(error))
  },
  data: () => ({
    username: null,
    password: null,
    error: false,
    version: null,
    releaseDate: null,
    prod: false
  }),
  methods: {
    login () {
      this.$store
        .dispatch('authorize', {
          username: this.username,
          password: this.password
        })
        .then(success => {
          if (success) {
            this.$store.state.user.user.group === 3 ||
            this.$store.state.user.user.group === 4
              ? this.$router.push('/analysis')
              : this.$router.push('/main')
          }
        })
        .catch(error => {
          this.error = true
        })
    },

    getValidDate (dateValue) {
      try {
        let d = new Date(dateValue * 1000)
        let date = d.getDate()
        let month = (d.getMonth() + 1).toString().slice(-2)
        return ((date < 10) ? '0' + date : date) + '.' + ((month < 10) ? '0' + month : month) + '.' + d.getFullYear()
      } catch (e) {
        console.log(e)
      }
    }
  }
}
</script>
<style lang="sass" scoped>
.container
  display: flex
  justify-content: center
  padding-top: 250px
.main_block
  margin: 0 50px
  display: grid
  grid-template-columns: 1fr auto
  grid-template-rows: 200px auto
  width: 1350px
  color: white
.webiomed
  display: flex
.webiomed .logo img
  width: 150px
.webiomed .text
  margin: 43px 0 0 30px
.webiomed .text .header
  font-size: 50px
  font-weight: 500
.webiomed .text .sub_text
  font-size: 17px
  letter-spacing: 0.3px
a
  color: white
  text-decoration: none
a:hover
  color: #ccc

// LOGIN FORM
.form
  color: #212121
  padding: 15px
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)
  background: white
  border-radius: 5px
.form *
  display: block
.form input
  width: 280px
  padding: 6px 12px
  font-size: 13px
  box-sizing: border-box
  height: 35px
  color: #555
  border: 1px solid #ccc
  border-radius: 4px
  margin-bottom: 15px
.form input:focus
  border-color: rgba(26, 163, 255, 0.8)
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.075) inset, 0 0 8px rgba(0, 153, 255, 0.6)
.form label
  font-weight: 500
  margin-bottom: 5px
  box-sizing: border-box
  font-size: 17px
.btn button
  font-size: 14px
  border-radius: 4px
  cursor: pointer
  font-weight: 400
  border: none
  background: #035cc9
  height: 34px
  padding: 0 14px
  color: white
  transition: all .3s ease-out

.btn button:disabled
  display: none
.btn button:hover
  background: #024597
.error_text
  color: #f8333c
  margin-top: 15px
  font-size: 16.5px
  max-width: 280px
  padding-bottom: 15px
.join
  margin-top: 12px
  display: grid
  align-content: center
  text-align: center
  grid-template-columns: auto auto
.social_text
  font-size: 16px
.social_icons a
  margin-right: 12px

// DISCLAIMER
.info
  margin-top: 100px
  line-height: 22px
  letter-spacing: 0.3px
  font-size: 15px
.info .section2
  border-top: 1px dotted white
  width: 600px
  margin-top: 10px
  padding-top: 10px
.i
  position: absolute
  color: black
  font-size: 20px
  z-index: 1
.user_name
  top: 71px
  left: 65px
.password
  top: 136px
  left: 65px

// MEDIA QUERIES
@media screen and (max-width: 950px)
  .container
    padding-top: 20px
    padding-left: 10%
  .main_block
    grid-template-columns: 1fr
    grid-template-rows: auto auto auto
  .webiomed
    // border: 1px solid red
  .webiomed .logo img
    width: 50px
    margin-right: 20px
  .webiomed .text
    margin: 0
  .webiomed .text .header
    font-size: 30px
  .webiomed .text .sub_text
    font-size: 17px
    letter-spacing: 0.1px
    font-weight: 450
  .login
    margin-top: 70px
  .form
    max-width: 455px
  .form input
    width: 100%
  .join
    margin-top: 15px
    display: grid
    justify-content: left
    grid-template-columns: auto auto
  .social_text
    font-size: 16px
    margin-right: 15px
  .social_icons a
    margin-right: 7px
  .info
    margin-top: 70px

@media screen and (max-width: 1400px)
  .container
    justify-content: left
    padding-top: 150px
@media screen and (max-width: 1300px)
  .container
    justify-content: left
    padding-top: 100px
@media screen and (max-width: 1100px)
  .container
    justify-content: left
    padding-top: 50px
@media screen and (max-width: 960px)
  .container
    justify-content: left
    padding-top: 20px
  .login
    margin: 5px
  .main_block
    margin: 0 30px
</style>
